// React

// Redux
import { useSelector } from 'react-redux';

// FutureLab
import { ChatListDataInterface } from './ChatListItemsDesktop';
import { UserDetailsListItem } from '../../model';
import { LoggedInUserDetails } from '../../reducers/index';
import { getQueryResults } from '../../utilities/Chat';
import { RootState } from '../../reducers/index';
import { ChatListChatRequest } from './ChatListChatRequest';
import { store } from '../../ReduxRoot';

import { Button } from '../ui/button';

interface ChatListChatRequestComponentsInterface {
	loggedInUserDetail: LoggedInUserDetails;
	userListProfilesDetails: UserDetailsListItem[];
	filterQuery: any;
}

export function ChatListChatRequestLoop(
	ChatListChatRequestComponentsInterface: ChatListChatRequestComponentsInterface
) {
	const { loggedInUserDetail, userListProfilesDetails, filterQuery } = ChatListChatRequestComponentsInterface;
	const pendingApprovalChatLists = useSelector((state: RootState) => state.pendingApprovalChatList);
	return (
		<>
			{store.getState().pendingApprovalChatList.length > 0 ? (
				<>
					{getQueryResults(pendingApprovalChatLists, loggedInUserDetail, userListProfilesDetails, filterQuery)
						.length > 0 ? (
						<div className="h-[calc(100dvh-173px)] overflow-y-auto">
							<div className="chat-mobile-only">
							{getQueryResults(
								pendingApprovalChatLists,
								loggedInUserDetail,
								userListProfilesDetails,
								filterQuery
							).map((pendingApprovalChatList: ChatListDataInterface, index: number) => {
								return (
									<ChatListChatRequest
												key={index}
												pendingChatListsItem={pendingApprovalChatList}
												userListProfilesDetails={userListProfilesDetails}
												navigateOnSelect
											></ChatListChatRequest>
								);
								})}
							</div>
							<div className="chat-desktop-only">
								{getQueryResults(
									pendingApprovalChatLists,
									loggedInUserDetail,
									userListProfilesDetails,
									filterQuery
								).map((pendingApprovalChatList: ChatListDataInterface, index: number) => {
									return (
										<ChatListChatRequest
											key={index}
											pendingChatListsItem={pendingApprovalChatList}
											userListProfilesDetails={userListProfilesDetails}
											navigateOnSelect={false}
										></ChatListChatRequest>
									);
								})}
							</div>
						</div>
					) : (
						<div className="px-5 pt-10">
							<div>
								<div className="pb-3 text-center text-xl font-bold text-gray-900">
									No result found.
								</div>
								<div className="text-center text-base text-gray-600">
									Please refine your key words and try again
								</div>
							</div>
						</div>
					)}
				</>
			) : (
				<div className="px-5 pt-10">
					<div>
						<div className="pb-3 text-center text-xl font-bold text-gray-900">
							Send request chat to someone
						</div>
						<div className="text-center text-base text-gray-600">
							You don't have any request currently. Once you have booked a session with your mentor, it
							will appear here
						</div>
						<div className="pb-3 pt-5 text-center">
							<Button onClick={() => window.open('https://futurelab.global/discover/mentors?lang=en', '_blank')}>
								Book a Session
							</Button>
						</div>
					</div>
				</div>
			)}
		</>
	);
}
